export default "__VITE_ASSET__BR21UFhq__"